import { connect } from 'react-redux'
import { unreadMessagesRequest } from 'store/ducks/messaging'
import BackgroundActivities from './presentational'

const mapStateToProps = (state, props) => {
  return {
    profile: state.profile.payload,
  }
}

const mapDispatchToProps = (dispatch, props) => ({
  unreadMessagesRequest: () => dispatch(unreadMessagesRequest()),
})

export default connect(mapStateToProps, mapDispatchToProps)(BackgroundActivities)
